<div class="sol-detail-wrapper" (mousemove)="onDragMove($event)">
  <div class="sol-detail-center-column" [class.sol-detail-center-column-embedded]="embedded$()">
    <ng-content></ng-content>
  </div>
  <div
    data-shortcut-layer="detail"
    [class]="fixed$() ? 'sol-detail-overlay-fixed' : 'sol-detail-overlay'"
    [class.sol-detail-hidden]="!visible$()"
  >
    <div
      [class.sol-detail-container]="visible$()"
      [class.sol-detail-container-fixed]="fixed$()"
      [class.sol-detail-container-closing]="closing$()"
      #detailContainer
    >
      <div
        class="sol-detail-drag-handle"
        [class.sol-detail-hidden]="!visible$()"
        (mousedown)="onDragStart($event)"
      ></div>
      <ng-container #detail></ng-container>
    </div>
  </div>
</div>
